/**
 * @generated SignedSource<<dbebb66694e01df7e4e6b11a8f1b2349>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpsertAutoNutritionInput = {
  alcohol?: number | null | undefined;
  calories?: number | null | undefined;
  carbs?: number | null | undefined;
  cholesterol?: number | null | undefined;
  clientMutationId?: string | null | undefined;
  date?: string | null | undefined;
  fat?: number | null | undefined;
  fiber?: number | null | undefined;
  id?: string | null | undefined;
  protein?: number | null | undefined;
  sodium?: number | null | undefined;
  sugar?: number | null | undefined;
  transFat?: number | null | undefined;
};
export type AddAutoNutritionEntryFormCreateMutation$variables = {
  input: UpsertAutoNutritionInput;
};
export type AddAutoNutritionEntryFormCreateMutation$data = {
  readonly upsertAutoNutrition: {
    readonly autoNutrition: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type AddAutoNutritionEntryFormCreateMutation = {
  response: AddAutoNutritionEntryFormCreateMutation$data;
  variables: AddAutoNutritionEntryFormCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertAutoNutritionPayload",
    "kind": "LinkedField",
    "name": "upsertAutoNutrition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AutoNutrition",
        "kind": "LinkedField",
        "name": "autoNutrition",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddAutoNutritionEntryFormCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddAutoNutritionEntryFormCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e7295365d04abc4e43f460444effc24a",
    "id": null,
    "metadata": {},
    "name": "AddAutoNutritionEntryFormCreateMutation",
    "operationKind": "mutation",
    "text": "mutation AddAutoNutritionEntryFormCreateMutation(\n  $input: UpsertAutoNutritionInput!\n) {\n  upsertAutoNutrition(input: $input) {\n    autoNutrition {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c6842ce0da180774ee84502997b1d4b9";

export default node;
